__turbopack_context__.v({
  "divider": "VIe4uW_divider",
  "eyebrow": "VIe4uW_eyebrow",
  "inlineLinkCard": "VIe4uW_inlineLinkCard",
  "metaGrid": "VIe4uW_metaGrid",
  "pageLead": "VIe4uW_pageLead",
  "pageTitle": "VIe4uW_pageTitle",
  "policyContainer": "VIe4uW_policyContainer",
  "policyPage": "VIe4uW_policyPage",
  "section": "VIe4uW_section",
  "sectionBody": "VIe4uW_sectionBody",
  "sectionTitle": "VIe4uW_sectionTitle",
  "timelineTable": "VIe4uW_timelineTable",
});
